import React, {
  useMemo,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import moment from "moment-jalaali";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
// import useHttp from '../../hooks/http';
import useAsync from "../../hooks/asyncRequests";
import Header from "../../Components/UI/Header/Header";
import Footer from "../../Components/UI/Footer/Footer";
import { useLocation } from "react-router";
// import Icon from '@mdi/react';
// import { mdiCloudUploadOutline } from '@mdi/js';
import Icon from "@mdi/react";
import { mdiCloudUploadOutline, mdiPageFirst, mdiPageLast } from "@mdi/js";
import CInput from "../../Components/UI/CInput/CInput";
import rainfalImg from "../../assets/Charts/rainfal.png";
import tabkhirImg from "../../assets/Charts/tabkhir.png";
import deepSnowImg from "../../assets/Charts/deep-snow.png";
import heightSnowImg from "../../assets/Charts/height-snow.png";
import densitySnowImg from "../../assets/Charts/density-snow.png";
import { Helmet } from "react-helmet";

const Select = (props) => {
  const { list, value, setValue, Color, last } = props;

  return (
    <ul
      className="selectList"
      style={{ borderColor: value && Color ? `rgb(${Color})` : "black" }}
    >
      {list.map((item) => (
        <li
          key={item.gainValue}
          className={value === item.gainValue ? "active" : ""}
          onClick={() => setValue(item.gainValue)}
          style={{
            backgroundColor:
              value === item.gainValue && Color ? `rgba(${Color}, 0.4)` : "",
          }}
        >
          <img src={item.img} alt={item.value} />
          <div>
            <div>{item.value}</div>
            <div>
              {!!last && !!last[item.type] && last[item.type][item.gainValue]}
              {!!last &&
                item.type !== "snow" &&
                !!last[item.type] &&
                last[item.type]["value"]}{" "}
              ({item.unit})
            </div>
            <div>
              {last &&
                last[item.type] &&
                moment(last[item.type].date).isValid() &&
                moment(last[item.type].date).format("jYYYY/jMM/jDD")}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

// const WareHouse =
const thisPageData = {
  options: [
    {
      value: "بارش",
      gainValue: "rain",
      unit: "mm",
      type: "rain",
      color: "130, 177, 255",
      img: rainfalImg,
    },
    {
      value: "عمق برف",
      gainValue: "deep_snow",
      unit: "mm",
      type: "snow",
      color: "22, 101, 193",
      img: deepSnowImg,
    },
    {
      value: "چگالی برف",
      gainValue: "density",
      unit: "mm",
      type: "snow",
      color: "25, 118, 211",
      img: densitySnowImg,
    },
    {
      value: "ارتفاع برف آبه",
      gainValue: "attitude_water_snow",
      unit: "mm",
      type: "snow",
      color: "33, 150, 243",
      img: heightSnowImg,
    },
    // { value: 'دمای حداقل', gainValue: 'minimum_temp', unit: 'mm', type: 'temperature', color: '255, 127, 126' },
    // { value: 'دمای متوسط', gainValue: 'medium_temp', unit: 'mm', type: 'temperature', color: '236, 88, 88' },
    // { value: 'دمای حداکثر', gainValue: 'maximum_temp', unit: 'mm', type: 'temperature', color: '198, 60, 60' },
    {
      value: "تبخیر",
      gainValue: "evp",
      unit: "mm",
      type: "evp",
      color: "179, 229, 252",
      img: tabkhirImg,
    },
  ],
  title: "ایستگاه هواشناسی",
};

const WeatherStation = () => {
  const [chartData, setChartData] = useState({});
  const [value, setValue] = useState(
    thisPageData.options[thisPageData.options.length - 1].gainValue
  );
  const [Range, setRange] = useState(1);

  const token = useSelector((state) => state.auth.Token);
  const location = useLocation();

  const { isLoadingAsync, finalData, clearAsync, Key, NewRequest } = useAsync(
    location.state.id
      ? {
          Key: 1,
          reqData: {
            weather: {
              url: `chart/weather/?range=1&station_id=${location.state.id}`,
              method: "GET",
              header: { Authorization: `Bearer ${token}` },
            },
            // temperature: {
            //   url: `chart/temperature/?range=1&station_id=${location.state.id}`,
            //   method: "GET",
            //   header: { Authorization: `Bearer ${token}` },
            // },
            snow: {
              url: `chart/snow/?range=1&station_id=${location.state.id}`,
              method: "GET",
              header: { Authorization: `Bearer ${token}` },
            },
          },
        }
      : null
  );

  const [AllChartData, setAllChartData] = useState({});
  const [Color, setColor] = useState({});
  const [Start, setStart] = useState(moment());
  const [End, setEnd] = useState(moment());
  const chartRef = useRef(null);
  const [last, setLast] = useState({
    snow: "",
    rain: "",
    evp: "",
  });

  useEffect(() => {
    const colors = {};
    thisPageData.options.forEach((element) => {
      colors[element.gainValue] = element.color;
    });
    setColor(colors);

    console.log(colors);
  }, [setColor]);

  useEffect(() => {
    console.log(finalData);
    if (!finalData || !Key || Key === "loading") {
      return;
    }

    if (AllChartData[Key]) {
      return;
    }

    const { weather, snow } = finalData;
    setLast({
      snow: snow.latest,
      rain: weather.latest_rain,
      evp: weather.latest_evp,
    });
    const latest = {};
    const allChartData = {
      labels: { temperature: [], snow: [], rain: [], evp: [] },
    };

    if (!weather.error) {
      const the = ["rain", "evp"];
      the.forEach((e) => {
        latest[e] = {
          ...weather["latest_" + e],
          date: moment(weather["latest_" + e].date).format("jYYYY-jMM-jDD"),
        };
        allChartData[e] = [];
        weather[e].forEach((element) => {
          const date = moment(element.date).format("jYYYY-jMM-jDD");
          allChartData.labels[e].push(date);

          allChartData[e].push({
            y: element.value,
            x: date,
          });
        });
      });
    }

    // if (temperature.temp.length > 0) {
    //   latest.temperature = {
    //     ...temperature.latest,
    //     date: moment(temperature.latest.date).format("jYYYY-jMM-jDD"),
    //   };
    //   for (const temps in temperature.temp[0]) {
    //     allChartData[temps] = [];
    //   }
    //   temperature.temp.forEach((e) => {
    //     const dateee = moment(e.date).format("jYYYY-jMM-jDD");
    //     for (const temps in e) {
    //       allChartData[temps].push({ y: e[temps], x: dateee });
    //     }
    //   });
    //   // allChartData.date.forEach((e) => {
    //   //   allChartData.labels.temperature.push(moment(e).format('jYYYY-jMM-jDD'));
    //   // });
    //   delete allChartData.date;
    // }

    if (!snow.error && snow.data?.length > 0) {
      latest.snow = {
        ...snow.latest,
        date: moment(snow.latest.date).format("jYYYY-jMM-jDD"),
      };
      for (const snows in snow.data[0]) {
        allChartData[snows] = [];
      }
      snow.data.forEach((e) => {
        const datee = moment(e.date).format("jYYYY-jMM-jDD");
        for (const snows in e) {
          allChartData[snows].push({ y: e[snows], x: datee });
        }
        allChartData.labels.snow.push(datee);
      });
      // allChartData.date.forEach((e) => {
      //   allChartData.labels.snow.push(e && moment(e).format('jYYYY-jMM-jDD'));
      // });
      delete allChartData.date;
    }

    console.log(allChartData);
    setAllChartData((pre) => {
      const p = { ...pre };
      p[Key] = allChartData;
      return p;
    });

    setChartData({
      data: {
        datasets: [
          {
            pointHoverRadius: 5,
            pointHitRadius: 30,
            tension: 0.4,
            fill: false,
            cubicInterpolationMode: "monotone",
            parsing: false,
          },
        ],
      },
      options: {
        animation: false,
        normalized: true,
        spanGaps: true,
        // showLine: false,
        datasets: {
          line: {
            pointRadius: 0, // disable for all `'line'` datasets
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          yAxes: {
            title: {
              display: true,
              // text: 'yAxisTitle',
              font: {
                size: 15,
              },
            },
          },
          xAxes: {
            x: {
              type: "time",
              time: {
                unit: "month",
              },
            },
            title: {
              display: true,
              text: "زمان",
              font: {
                size: 15,
                family: "IRANSansWeb",
                weight: "bold",
              },
            },
            ticks: {
              maxTicksLimit: 12,
            },
          },
        },
      },
    });

    clearAsync();
  }, [finalData, setAllChartData, setChartData, clearAsync, AllChartData, Key]);

  useEffect(() => console.log(AllChartData), [AllChartData]);
  useEffect(() => console.log(Key), [Key]);

  // const download = useCallback(() => {
  //   fetch(chartRef.current.toBase64Image(), {
  //     method: 'GET',
  //     headers: {},
  //   })
  //     .then((response) => {
  //       response.arrayBuffer().then(function (buffer) {
  //         const url = window.URL.createObjectURL(new Blob([buffer]));
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', `${value}.png`);
  //         document.body.appendChild(link);
  //         link.click();
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [chartRef, value]);

  const chart = useMemo(() => {
    if (chartData) {
      let dt = null;
      if (chartData.data && chartData.data.datasets[0].data) {
        dt = chartData;
      }

      return dt && <Line ref={chartRef} {...dt} />;
    }
  }, [chartData, chartRef]);

  const downloadCSV = useCallback(() => {
    fetch(
      `http://213.233.177.17:8022/download/weather_detail?weather_station_id=${
        location.state.id
      }&start_date=${Start.format("YYYY-MM-DD")}&end_date=${End.format(
        "YYYY-MM-DD"
      )}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        // response.headers.forEach((value, name) => {
        //   console.log(name + ': ' + value);
        // });
        // console.log(response.headers.get('Content-Disposition'));
        return response.blob().then((data) => {
          return {
            blob: data,
            // filename: response.headers.get('Content-disposition'),
          };
        });
      })
      .then(({ blob }) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "weather.zip";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again)
      })
      .catch((error) => {
        console.log(error);
      });
  }, [token, location, Start, End]);

  const downloadUI = useMemo(() => {
    return (
      <div className="chartDownload">
        <CInput
          config={{
            type: "calendar",
            placeholder: "تاریخ شروع",
          }}
          value={Start}
          direction="rtl"
          changed={setStart}
        />
        <CInput
          config={{
            type: "calendar",
            placeholder: "تاریخ پایان",
          }}
          value={End}
          direction="rtl"
          changed={setEnd}
        />
        <button onClick={() => downloadCSV()}>
          دریافت داده ها به فرمت CSV{" "}
          <Icon path={mdiCloudUploadOutline} size={1} />
        </button>
      </div>
    );
  }, [downloadCSV, Start, End, setStart, setEnd]);

  useEffect(() => {
    if (value && AllChartData[Range]) {
      const thisValue = thisPageData.options.find((e) => e.gainValue === value);

      setChartData(
        (pre) =>
          pre &&
          Object.keys(pre).length && {
            ...pre,
            data: {
              labels: AllChartData[Range].labels[thisValue.type],
              datasets: [
                {
                  ...pre.data.datasets[0],
                  label: value,
                  data: AllChartData[Range][value],
                  backgroundColor: `rgb(${Color[value]})`,
                  borderColor: `rgb(${Color[value]})`,
                },
              ],
            },
            options: {
              ...pre.options,
              scales: {
                ...pre.options.scales,
                yAxes: {
                  title: {
                    ...pre.options.scales.yAxes.title,
                    text: thisValue.value,
                    // text: lbDic[value] ?? value,
                    font: {
                      size: 15,
                      family: "IRANSansWeb",
                      weight: "bold",
                    },
                  },
                },
              },
            },
          }
      );
    }
  }, [value, setChartData, AllChartData, Color, Range]);

  useEffect(() => {
    if (!AllChartData[Range] && Range !== 1) {
      NewRequest({
        NewKey: Range,
        NewReqData: {
          weather: {
            url: `chart/weather/?range=${Range}&station_id=${location.state.id}`,
            method: "GET",
            header: { Authorization: `Bearer ${token}` },
          },
          temperature: {
            url: `chart/temperature/?range=${Range}&station_id=${location.state.id}`,
            method: "GET",
            header: { Authorization: `Bearer ${token}` },
          },
          snow: {
            url: `chart/snow/?range=${Range}&station_id=${location.state.id}`,
            method: "GET",
            header: { Authorization: `Bearer ${token}` },
          },
        },
      });
    }
  }, [NewRequest, Range, AllChartData, location, token]);

  const navigation = useMemo(() => {
    return (
      <div className="center">
        <span onClick={() => setRange((pre) => pre + 1)}>
          <Icon
            path={mdiPageLast}
            title="NEXT"
            size={1}
            style={{ visibility: !Range ? "hidden" : "visible" }}
          />
        </span>
        <span>{Range}</span>
        <span onClick={() => setRange((pre) => (pre === 1 ? 1 : pre - 1))}>
          <Icon
            path={mdiPageFirst}
            title="PREVIOUS"
            size={1}
            style={{ visibility: Range === 1 ? "hidden" : "visible" }}
          />
        </span>
      </div>
    );
  }, [Range, setRange]);

  return (
    <SpinnerHandler isLoading={isLoadingAsync}>
      <Helmet>
        <title>نمودار هواشناسی</title>
      </Helmet>
      <Header />
      <div className="chartInfo">
        <h2>
          {thisPageData.title} {location.state.name}
        </h2>

        {thisPageData.options && (
          <Select
            value={value}
            setValue={setValue}
            list={thisPageData.options}
            Color={Color[value]}
            last={last}
          ></Select>
        )}
      </div>

      <div className="center damChart">
        {navigation}
        <div>{chart}</div>
      </div>

      {downloadUI}
      <Footer />
    </SpinnerHandler>
  );
};

export default WeatherStation;
